import APICRUD from './apiCrud'
import URL from './urls'

export class Roles extends APICRUD {
  index(options) {
    return this.http().get(`${URL.ROLES_URL}/index`, {
      params: options
    })
  }
}

export default new Roles()
